module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("f2w2R"))).then(() => parcelRequire('1iHdE'));